import React, { useCallback, useEffect, useState } from 'react';
import { Grid, Typography, TextField, Hidden, Box
    , FormControl, InputLabel, Select, Button } from '@mui/material';
import { Search as IconSearch, AddCircle as IconAddCircle } from "@mui/icons-material";
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import * as catalogoService from "../../services/catalogoService";
import { setValue, setResults, setListPadre } from '../../redux/catalogSearchSlice';
import DataGridBase from "../../components/common/DataGridBase";
import { useMantenimiento } from "../../hooks/useMantenimiento";

// Mantenimiento de catalogos. IdPadre es otro catalogo: los grupos (IdPadre = 0)
// son el filtro de la ventana de busqueda.
//
// El listado trae solo los ultimos registros por fecha de registro, para que la
// navegabilidad no cargue todos los catalogos de una vez.
const ULTIMOS_REGISTROS = 50;

const Index = () => {
    const { isReadOnly } = useMantenimiento("catalogo");
    const filters = useSelector((state) => state.catalogSearch.filters);
    const listPadre = useSelector((state) => state.catalogSearch.listPadre);

    const [cargando, setCargando] = useState(true);
    const [results, setResultsList] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const fetchResults = useCallback(async () => {
        setCargando(true);

        const data = await catalogoService.getsCatalogoSearch({
            idPadre: filters.idPadre == null ? 0 : filters.idPadre,
            codigo: filters.codigo == null ? "" : filters.codigo,
            descripcion: filters.descripcion == null ? "" : filters.descripcion,
            estado: filters.estado == null ? "" : filters.estado,
            // El listado muestra solo los ultimos registros por fecha de registro.
            ultimos: ULTIMOS_REGISTROS,
        })
            .catch((err) => { console.log("Err: ", err) });

        setResultsList((data || []).map((row) => ({ ...row, id: row.idCatalogo })));
        dispatch(setResults(data || []));
        setCargando(false);
    }, [filters])

    const fetchListPadre = useCallback(async () => {
        const data = await catalogoService.getsCatalogoPadre()
            .catch((err) => { console.log("Err: ", err) });

        dispatch(setListPadre(data || []));
    }, [])

    useEffect(() => {
        fetchListPadre();
    }, [])

    useEffect(() => {
        fetchResults();
    }, [fetchResults])

    const columns = [
        { field: 'id', headerName: 'ID', width: 50, minWidth: 45, sortable: true, headerAlign: 'center', align: 'center',
            renderCell: (p) => <span style={{ fontSize: '0.75rem', color: '#666', fontFamily: 'monospace' }}>{p.value != null ? p.value : p.row.id}</span> },
        { field: 'idCatalogo', headerName: 'Codigo', width: 90, sortable: false, headerAlign: 'center'
            , renderCell: (cellValues) => {
                return <Link to={'/catalog/edit/' + cellValues.row.idCatalogo} style={{ color: 'inherit' }}>
                    {cellValues.row.codigo}
                </Link>;
            }
        },
        { field: 'descripcion', headerName: 'Descripcion', width: 220, sortable: false, headerAlign: 'left' },
        { field: 'abreviado', headerName: 'Abreviado', width: 100, sortable: false, headerAlign: 'center' },
        { field: 'descripcionPadre', headerName: 'Padre', width: 200, sortable: false, headerAlign: 'left'
            , renderCell: (cellValues) => cellValues.row.descripcionPadre
                || (cellValues.row.idPadre == 0 ? "(Grupo)" : "")
        },
        { field: 'orden', headerName: 'Orden', width: 70, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'estado', headerName: 'Estado', width: 90, sortable: false, headerAlign: 'center', align: 'center'
            , renderCell: (cellValues) => cellValues.row.estado == "A" ? "Activo" : "Inactivo"
        },
    ];

    return (
        <div>
            <Grid container>
                <Grid item>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Catalogos
                    </Typography>
                </Grid>
                <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                    <Grid item xs={12} sm={12}>
                        <Grid container item xs={12} sm={12} spacing={1}>
                            <Grid item xs={6} sm={3}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-idPadre" shrink>Padre</InputLabel>
                                    <Select
                                        native
                                        label="Padre"
                                        value={filters.idPadre}
                                        onChange={(event) => {
                                            dispatch(setValue({ name: "idPadre", value: parseInt(event.target.value) }))
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{ name: 'idPadre', id: 'input-idPadre' }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listPadre.map((row) => (
                                            <option key={row.idCatalogo} value={row.idCatalogo}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <TextField
                                    name="codigo"
                                    label="Codigo"
                                    fullWidth
                                    value={filters.codigo}
                                    onChange={(event) => dispatch(setValue({ name: "codigo", value: event.target.value }))}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <TextField
                                    name="descripcion"
                                    label="Descripcion"
                                    fullWidth
                                    value={filters.descripcion}
                                    onChange={(event) => dispatch(setValue({ name: "descripcion", value: event.target.value }))}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    {/* shrink mantiene la etiqueta arriba: con el valor
                                        vacio de "(Todos)" se sobreponia al texto. */}
                                    <InputLabel htmlFor="input-estado" shrink>Estado</InputLabel>
                                    <Select
                                        native
                                        label="Estado"
                                        value={filters.estado}
                                        onChange={(event) => dispatch(setValue({ name: "estado", value: event.target.value }))}
                                        inputProps={{ name: 'estado', id: 'input-estado' }}
                                        size="small"
                                    >
                                        <option key="" value="">{"(Todos)"}</option>
                                        <option key="A" value="A">{"Activo"}</option>
                                        <option key="I" value="I">{"Inactivo"}</option>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={2} sm={2} display={"flex"} alignItems={"center"}>
                                <Button variant="outlined" size="medium" fullWidth onClick={() => { fetchResults() }}>
                                    {<Hidden smDown></Hidden>}
                                    <IconSearch />
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <DataGridBase
                                rows={results}
                                columns={columns}
                                loading={cargando}
                                disabled={isReadOnly}
                                toolbarButtons={[
                                    {
                                        text: "Nuevo",
                                        icon: <IconAddCircle />,
                                        disabled: isReadOnly,
                                        onClick: () => navigate("/catalog/edit/0")
                                    }
                                ]}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}
export default Index;